import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = ({ className = "" }) => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: '256-bit SSL Encryption',
      description: 'Your data is protected with bank-level security',
      status: 'active'
    },
    {
      icon: 'Lock',
      title: 'PCI DSS Compliant',
      description: 'Payment Card Industry Data Security Standard certified',
      status: 'active'
    },
    {
      icon: 'Eye',
      title: '3D Secure Authentication',
      description: 'Additional layer of security for card transactions',
      status: 'active'
    },
    {
      icon: 'Smartphone',
      title: 'OTP Verification',
      description: 'One-time password for secure transaction approval',
      status: 'active'
    }
  ];

  const trustBadges = [
    {
      name: 'RBI Approved',
      icon: 'Award',
      color: 'text-success'
    },
    {
      name: 'ISO 27001',
      icon: 'Certificate',
      color: 'text-primary'
    },
    {
      name: 'Norton Secured',
      icon: 'Shield',
      color: 'text-warning'
    }
  ];

  return (
    <div className={`space-y-6 ${className}`}>
      {/* Security Features */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="ShieldCheck" size={20} className="text-success" />
          <h3 className="font-heading font-semibold text-foreground">Security Features</h3>
        </div>
        
        <div className="space-y-4">
          {securityFeatures.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name={feature.icon} size={16} className="text-success" />
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <h4 className="font-medium text-foreground text-sm">{feature.title}</h4>
                  <div className="w-2 h-2 bg-success rounded-full"></div>
                </div>
                <p className="text-xs text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Trust Badges */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
        <h3 className="font-heading font-semibold text-foreground mb-4">Trusted & Certified</h3>
        
        <div className="grid grid-cols-1 gap-3">
          {trustBadges.map((badge, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
              <Icon name={badge.icon} size={16} className={badge.color} />
              <span className="font-medium text-foreground text-sm">{badge.name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Payment Security Notice */}
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-medium text-primary text-sm mb-1">Secure Payment Notice</h4>
            <p className="text-xs text-primary/80">
              Your payment information is encrypted and processed securely. We never store your card details on our servers.
            </p>
          </div>
        </div>
      </div>

      {/* Customer Support */}
      <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Headphones" size={20} className="text-secondary" />
          <h3 className="font-heading font-semibold text-foreground">24/7 Support</h3>
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={14} className="text-muted-foreground" />
            <div>
              <div className="text-sm font-medium text-foreground">1800-123-4567</div>
              <div className="text-xs text-muted-foreground">Toll-free support line</div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="MessageCircle" size={14} className="text-muted-foreground" />
            <div>
              <div className="text-sm font-medium text-foreground">Live Chat</div>
              <div className="text-xs text-muted-foreground">Available 24/7</div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={14} className="text-muted-foreground" />
            <div>
              <div className="text-sm font-medium text-foreground">support@drutravels.com</div>
              <div className="text-xs text-muted-foreground">Email support</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityIndicators;